import { render, staticRenderFns } from "./bpLogo.vue?vue&type=template&id=65fbc27a&"
import script from "./bpLogo.vue?vue&type=script&lang=js&"
export * from "./bpLogo.vue?vue&type=script&lang=js&"
import style0 from "./bpLogo.vue?vue&type=style&index=0&id=65fbc27a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports